import { forEach, map, reduce, merge, pickBy, orderBy, has } from 'lodash';
import { createSelector } from 'reselect';

import {
  GET_DATA_SAMPLES_SUCCESS,
  GET_DATA_CHARACTERISTICS_SUCCESS,
  GET_DATA_CHARACTERISTICS_FAILURE,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

import DataSamplesProcessor from '../../lib/DataSamplesProcessor';

const initialState = {};

export const samplesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_SAMPLES_SUCCESS:
      return getDataSetSamples(state, action);

    case GET_DATA_CHARACTERISTICS_SUCCESS:
      return getDataSetCharacteristics(state, action);

    case GET_DATA_CHARACTERISTICS_FAILURE:
      return dataSetCharacteristicsFailure(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};
export default samplesReducer;

function getDataSetSamples(state, action) {
  let {
    requestInfo: { id },
    receivedAt,
    result,
  } = action;
  let outSamples = [],
    outFlat = [];

  forEach(result, (s) => {
    outSamples.push(DataSamplesProcessor.rorderSampleProperties(s));
    outFlat.push(DataSamplesProcessor.flattenSamples(s));
  });

  let newSamples = {
    ...state[id],
    lastUpdated: receivedAt,
    original: {
      out: outSamples,
    },
    flat: {
      out: outFlat,
    },
  };

  return {
    ...state,
    [id]: newSamples,
  };
}

function getDataSetCharacteristics(state, action) {
  const {
    requestInfo: { id },
    result: { output },
    receivedAt,
  } = action;
  const newSamples = { ...state[id] };
  const characteristics = {
    ...output?.[0],
    byAttr: {},
  };

  forEach(characteristics.result, ({ attributeName, statistics }) => {
    const attributeStats = pickBy(reduce(statistics, merge), (value, key) => key);

    if (attributeStats.topValues) {
      attributeStats.topValues = orderBy(
        map(attributeStats.topValues, (percentage, value) => ({
          value,
          percentage:
            (percentage && percentage.endsWith('%') && parseFloat(percentage.slice(0, -1))) || 0,
        })),
        ['percentage'],
        ['desc'],
      );
    }

    characteristics.byAttr[attributeName] = attributeStats;
  });

  newSamples.lastUpdated = receivedAt;
  newSamples.characteristics = characteristics;

  return {
    ...state,
    [id]: newSamples,
  };
}

function dataSetCharacteristicsFailure(state, action) {
  let {
    requestInfo: { id },
    receivedAt,
  } = action;

  return {
    ...state,
    [id]: {
      ...state[id],
      lastUpdated: receivedAt,
      characteristics: {},
    },
  };
}

export const getSamplesForDataSet = createSelector(
  //TODO: memoization is not saving across Nexset id changes.
  //Create selector per Nexset id.
  [
    (state) => state.samples,
    (_, ownProps) => {
      return ownProps.data;
    },
  ],
  (samples, dataSet) => {
    let samplesForSet = {
      id: 0,
      lastUpdated: Date.now(),
      samples: null,
    };

    if (dataSet && has(samples, dataSet.id)) {
      const dataSetSamples = samples[dataSet.id];
      samplesForSet = {
        id: dataSet.id,
        lastUpdated: dataSetSamples.lastUpdated,
        samples: dataSetSamples.flat && dataSetSamples.flat.out,
        nestedSamples: dataSetSamples.original && dataSetSamples.original.out,
        characteristics: dataSetSamples.characteristics,
      };
    }
    return samplesForSet;
  },
);
